// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import edit05Icon from "@/assets/icons/edit-05.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Edit05IconProps = Omit<IconProps, "name">;

export function Edit05Icon(props: Edit05IconProps): React.ReactNode {
  return <Icon name={edit05Icon} {...props} />;
}
